import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AppLayout from "../components/layout/AppLayout";
import DiaryList from "../components/pages/list/DiaryList";
import Login from "../components/pages/login/Login";
import { useRecoilValue } from "recoil";
import { userState } from "../states/userState";
import SingleInput from "../components/pages/singleInput/SingleInput";
import DiaryMatrix from "../components/pages/matrix/DiaryMatrx";
import MultiInput from "../components/pages/multiInput/MultiInput";
import OutSourcingMailSetting from "../components/pages/outsourcingMailSetting/OutSourcingMailSetting";
import Auth from "../Auth";

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<AppLayout />}>
          <Route
            path="/"
            element={
              <Auth>
                <DiaryList />
              </Auth>
            }
          />
          <Route
            path="/matrix"
            element={
              <Auth>
                <DiaryMatrix />
              </Auth>
            }
          />
          <Route
            path="/outsourcing-mail-setting"
            element={
              <Auth>
                <OutSourcingMailSetting />
              </Auth>
            }
          />

          <Route
            path="/singleInput"
            element={
              <Auth>
                <SingleInput />
              </Auth>
            }
          />
          <Route
            path="/multiInput"
            element={
              <Auth>
                <MultiInput />
              </Auth>
            }
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
